var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-stretch"},[_vm._t("default",null,{"faulty":_vm.error,"touch":_vm.touch}),(_vm.error)?_c('div',_vm._l((Object.entries(_vm.errorcheckers).filter(function (ref) {
	var k = ref[0];
	var ec = ref[1];

	return _vm.validation[k] === false;
})),function(ref){
var k = ref[0];
var ec = ref[1];
return _c('div',{key:k,staticClass:"error"},[_vm._v(" "+_vm._s(ec(_vm.validation))+" ")])}),0):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }